var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'default-page')?_c('nav-bar'):_vm._e(),_c(_vm.layout,{tag:"component"}),(_vm.layout === 'default-page')?_c('chiral-footer'):_vm._e(),(!_vm.isMobile)?_c('side-operation'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }